import { util } from "jointjs";
import { KEAElement } from "./KEAElement";

export class KEAUMLComplexState extends KEAElement {
  defaults() {
    return util.defaultsDeep({
      ...super.defaults(),
      type: "kea.UMLComplexState",
      size: {
        width: 200,
        height: 100,
      },
      attrs: {
        body: {
          refWidth: "100%",
          refHeight: "100%",
          rx: 10,
          ry: 10,
          fill: "#ecf0f1",
          stroke: "#bdc3c7",
          strokeWidth: 3,
          fillOpacity: 0.6,
        },
        label: {
          ref: "body",
          textVerticalAnchor: "middle",
          textAnchor: "middle",
          refX: 0.5,
          refY: 10,
          fontSize: 14,
          text: "",
          fill: "#333333",
        },
        umlStateSeparator: {
          stroke: "#bdc3c7",
          "stroke-width": 2,
          rx: 10,
          ry: 10,
          fill: "none",
          refWidth: "100%",
          height: 25,
        },
        umlStateEvents: {
          ref: "body",
          refX: 5,
          refY: 30,
          fill: "#333333",
          fontSize: 14,
          text: "",
        },
        resize_border_right: {
          width: 10,
          refHeight: "100%",
          refX: "100%",
          refY: "0%",
          stroke: "none",
          fill: "none",
          cursor: "se-resize",
          pointerEvents: "visible",
          event: "keaelement:resize",
        },
        resize_border_bottom: {
          refWidth: "100%",
          height: 10,
          refX: "0%",
          refY: "100%",
          stroke: "none",
          fill: "none",
          cursor: "se-resize",
          pointerEvents: "visible",
          event: "keaelement:resize",
        },
      },
      name: "",
      events: "",
      minHeight: 100,
      minWidth: 200,
      resizeHeight: true,
      resizeWidth: true,
    });
  }

  onChangePrimaryColor(element: KEAElement, _property: string, _options: any): void {
    element.attr({
      body: { fill: _property },
    });
  }

  onChangeSecondaryColor(element: KEAElement, _property: string, _options: any): void {
    element.attr({
      body: { stroke: _property },
      umlStateSeparator: { stroke: _property },
    });
  }

  onChangeLabelColor(element: KEAElement, _property: string, _options: any): void {
    element.attr({
      label: { fill: _property },
      umlStateEvents: { fill: _property },
    });
  }

  onChangeResizeHeight(_element: KEAElement, property: boolean, _options: any): void {
    if (property) {
      this.attr({
        resize_border_bottom: {
          cursor: "se-resize",
          event: "keaelement:resize",
        },
      });
    } else {
      this.attr({
        resize_border_bottom: {
          cursor: "default",
          event: undefined,
        },
      });
    }
  }

  onChangeResizeWidth(_element: KEAElement, property: boolean, _options: any): void {
    if (property) {
      this.attr({
        resize_border_right: {
          cursor: "se-resize",
          event: "keaelement:resize",
        },
      });
    } else {
      this.attr({
        resize_border_right: {
          cursor: "default",
          event: undefined,
        },
      });
    }
  }

  private getBodyMarkup = () => {
    let markup = [
      {
        tagName: "rect",
        selector: "body",
      },
      {
        tagName: "rect",
        selector: "umlStateSeparator",
      },
      {
        tagName: "text",
        selector: "label",
      },
      {
        tagName: "text",
        selector: "umlStateEvents",
      },
    ];
    if (this.getResizeWidth()) {
      markup.push({
        tagName: "rect",
        selector: "resize_border_right",
      });
    }
    if (this.getResizeHeight()) {
      markup.push({
        tagName: "rect",
        selector: "resize_border_bottom",
      });
    }
    return markup;
  };

  markup = this.getBodyMarkup();

  onChangeLabel(_element: KEAElement, property: string, _options: any): void {
    this.attr({
      label: { text: property },
    });
  }

  getEvents = (): string => {
    return this.get("events");
  };

  setEvents = (value: string): KEAUMLComplexState => {
    this.set("events", value);
    this.attr({
      umlStateEvents: {
        text: value,
      },
    });
    this.trigger("change:attribute", this);
    return this;
  };
}
